export const OpenSansRegular = {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
     src: url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.eot'), /* IE9 Compat Modes */
     src: local(''),
          url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
          url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.woff2') format('woff2'), /* Super Modern Browsers */
          url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.woff') format('woff'), /* Modern Browsers */
          url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.ttf') format('truetype'), /* Safari, Android, iOS */
          url('./fontOpenSans/open-sans-v18-latin_cyrillic-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
  `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const OpenSansSemiBold = {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `
       src: url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.eot'); /* IE9 Compat Modes */
       src: local(''),
            url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
            url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.woff2') format('woff2'), /* Super Modern Browsers */
            url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.woff') format('woff'), /* Modern Browsers */
            url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.ttf') format('truetype'), /* Safari, Android, iOS */
            url('./fontOpenSans/open-sans-v18-latin_cyrillic-600.svg#OpenSans') format('svg'); /* Legacy iOS */
  `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const PTSansRegular = {
    fontFamily: 'PT Sans',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
       src: url('./fontPTSans/pt-sans-v12-latin-regular.eot'); /* IE9 Compat Modes */
       src: local(''),
       url('./fontPTSans/pt-sans-v12-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./fontPTSans/pt-sans-v12-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('./fontPTSans/pt-sans-v12-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('./fontPTSans/pt-sans-v12-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./fontPTSans/pt-sans-v12-latin-regular.svg#PTSans') format('svg'); /* Legacy iOS */
  `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
